export const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

export const PASSWORD_STRENGTH = {
  EMPTY: '',
  WEAK: 'Weak',
  MEDIUM: 'Medium',
  STRONG: 'Strong'
}
